/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Win_Back_Paywall_Benefit_Focus_ChallengeInputs */

const en_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra Focus Challenge rewards`)
};

const ar_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكافآت إضافية في تحديات التركيز`)
};

const de_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusätzliche Belohnungen für Fokus-Herausforderungen`)
};

const es_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensas extra de Desafíos de concentración`)
};

const fr_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récompenses supplémentaires du Défi de Concentration`)
};

const it_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricompense extra della Sfida di Concentrazione`)
};

const ja_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中チャレンジの追加報酬`)
};

const ko_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 챌린지 추가 보상`)
};

const pt_br_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensas extras do Desafio de Foco`)
};

const ru_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительные награды за задание по фокусировке`)
};

const th_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลเพิ่มเติมจากความท้าทายการโฟกัส`)
};

const tr_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma Mücadeleleri için ek ödüller`)
};

const zh_cn_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注挑战额外奖励`)
};

const zh_tw_win_back_paywall_benefit_focus_challenge = /** @type {(inputs: Win_Back_Paywall_Benefit_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注挑戰額外獎勵`)
};

/**
* | output |
* | --- |
* | "Extra Focus Challenge rewards" |
*
* @param {Win_Back_Paywall_Benefit_Focus_ChallengeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const win_back_paywall_benefit_focus_challenge = /** @type {((inputs?: Win_Back_Paywall_Benefit_Focus_ChallengeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Win_Back_Paywall_Benefit_Focus_ChallengeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "ar") return ar_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "de") return de_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "es") return es_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "fr") return fr_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "it") return it_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "ja") return ja_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "ko") return ko_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "pt_br") return pt_br_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "ru") return ru_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "th") return th_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "tr") return tr_win_back_paywall_benefit_focus_challenge(inputs)
	if (locale === "zh_cn") return zh_cn_win_back_paywall_benefit_focus_challenge(inputs)
	return zh_tw_win_back_paywall_benefit_focus_challenge(inputs)
});